/**
 * Reception Component
 * 
 * Displays the reception events and celebrations.
 * Shows evening reception gathering and dinner with special styling.
 */

import React, { useEffect } from 'react';
import './Reception.css';

// Centralized imports
import { useAuth, AuthGuard } from '../utils/auth';
import { useScrollWobble } from '../utils/scrollAnimations';
import { PAGE_EVENTS, VENUE_INFO } from '../data/eventsData';
import EventCard from '../components/EventCard';
import ClosingSection from '../components/shared/ClosingSection';

function Reception() {
  // Use centralized authentication hook
  const { isValidAccess, isLoading } = useAuth('/rfeucnecpttiioonn');
  
  // Use centralized scroll animation hook
  useScrollWobble();

  // Get reception events from centralized data
  const events = PAGE_EVENTS.reception();

  // Reception-specific styling effect
  useEffect(() => {
    // Apply reception-specific body styling
    document.body.classList.add('reception-body');

    // Cleanup function to remove styling on unmount
    return () => {
      document.body.classList.remove('reception-body');
    };
  }, []);

  return (
    <AuthGuard isLoading={isLoading} isValidAccess={isValidAccess}>
      <div className="app">
        {/* Hero Section */}
        <div className="hero">
          <div className="hero-text">
            <img src={`${process.env.PUBLIC_URL}/logo2.png`} alt="Wedding Logo" className="hero-logo" />
            <h1>Radhika & Vivek</h1>
            <p>warmly welcome you to their Reception</p>
            <p>25th Nov 2025</p>
          </div>
        </div>

        {/* Hero Text Section for Mobile */}
        <div className="hero-text-section">
          <div className="hero-text-content">
            <img src={`${process.env.PUBLIC_URL}/logo2.png`} alt="Wedding Logo" className="hero-logo" />
            <h1>Radhika & Vivek</h1>
            <p>warmly welcome you to their Reception</p>
            <p>25th Nov 2025</p>
          </div>
        </div>

        <div className="gradient-container">
          {/* Location Section */}
          <div className="location-section">
          <div className="location-container">
            <div className="location-title">
              <img src="/location.png" alt="Location" className="location-icon" />
              <h2>Reception Venue</h2>
            </div>
            <div className="location-details">
              <h3>{VENUE_INFO.name}</h3>
              <div className="location-address">
                {VENUE_INFO.address.map((line, index) => (
                  <p key={index}>{line}</p>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Reception Events Section */}
        <div className="agenda">
          {/* Reception Header */}
          <div className="day-section">
            <div className="day-header">
              <h2>Reception Evening</h2>
              <div className="date-ornament">
                <span className="ornament">🌟</span>
                <span className="date">Tuesday, 25th Nov 2025</span>
                <span className="ornament">🌟</span>
              </div>
            </div>
          </div>

          {/* Event Cards */}
          {events.map((event, index) => (
            <EventCard 
              key={event.id} 
              event={event} 
              isReversed={index % 2 === 1}
            />
          ))}
        </div>


          {/* Closing Section */}
          <ClosingSection variant="simple" />
        </div>
      </div>
    </AuthGuard>
  );
}

export default Reception;